/**
 * Test-SCO-Model
 * @class service_v3sTestPauk
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sSco
 */
angular.module('v3sWbtPlayerApp').factory('v3sTestPauk', ["v3sTest", "v3sPots", function (v3sTest, v3sPots) {

    // instantiate the sco object
    var v3sTestPauk = function (data, options) {
        // use the original item object constructor
        v3sTest.apply(this, arguments);

        this.loadConfig({
            pots: v3sPots.PAUK,
            evaluateAllSelected: true,
            evaluationVisible: false,
            evaluationVisibleAfterFinished: false,
            generalFeedbackVisible: false
        });
    };

    // use the original v3sSco prototype
    v3sTestPauk.prototype = new v3sTest();

    v3sTestPauk.prototype.getScore = function () {
        var score = 0;

        var statistic = this.getAllExerciseStatistic();
        if (statistic.all == statistic.sometimePassed) {
            score = 100;
        }

        return score;
    };

    return v3sTestPauk;
}]);
